"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  vgmApply: {
    title: 'VGM 申报',
    blNo: '提单号',
    containerNo: '箱号',
    bkNo: '订舱号',
    importFlag: '导入状态',
    wait: '等待接收',
    accepted: '已接收',
    refuse: '已拒绝',
    vesselCode: '船舶代码',
    voyageNo: '航次',
    vgmGrossWeight: 'VGM\n箱总重',
    vgmScale: 'VGM\n称重单位',
    vgmMethod: 'VGM\n称重方法',
    vgmDate: 'VGM\n称重时间',
    location: 'VGM\n称重地点',
    rejectReason: '拒绝原因',
    operate: '操作',
    addSuccess: '添加成功',
    addFail: '添加失败',
    delConfirm: '确认删除',
    delSuccess: '删除成功',
    delFail: '删除失败',
    failures: '失败',
    fileSize: '文件大小不能超过500KB!',
    checkSuccess: '校验成功!'
  },
  button: {
    search: '查询',
    reset: '重置',
    edit: '编辑',
    view: '查看',
    delete: '删除',
    save: '保存',
    saveCopy: '保存并拷贝',
    saveNew: '保存并新增',
    back: '返回',
    new: '新增',
    copy: '拷贝',
    excel: 'Excel导出',
    print: '打印',
    pdf: 'pdf导出',
    importExcel: '导入EXCEL',
    excelTemplate: 'EXCEL模板',
    sure: '确定',
    cancel: '取消'
  },
  vgmApplyInfo: {
    title: 'VGM详细信息',
    vvl: '船名航次',
    blNo: '提单号',
    containerNo: '箱号',
    bkNo: '订舱号',
    importFlag: '导入状态',
    wait: '等待接收',
    accepted: '已接收',
    refuse: '已拒绝',
    vesselCode: '船舶代码',
    voyageNo: '航次',
    voyageLeg: '航段',
    vgmGrossWeight: 'VGM箱总重',
    vgmScale: 'VGM称重单位',
    vgmMethod: 'VGM称重方法',
    vgmDate: 'VGM称重时间',
    location: 'VGM称重地点',
    rejectReason: '拒绝原因',
    vesselName: '船舶名称',
    vesselName1: '船舶名称(CN)',
    containerType: '箱型',
    containerOther: '其他',
    remark: '备注',
    shipperName: '发货人名',
    shipperAddress: '发货人联系地址',
    shipperVgmName: 'VGM联系人',
    shipperVgmEmail: 'VGM联系邮箱',
    shipperVgmTelephone: 'VGM联系方式',
    vgmCertificateId: 'VGM证书ID',
    shipperVgmPerson: 'VGM负责人',
    shipperVgmPersonSig: 'VGM负责人签名',
    vgmDeclarationParty: 'VGM申报企业',
    vgmEquipmentId: 'VGM称重设备号',
    shipperOther: '其他',
    name: '名',
    contactName: '联系人',
    contactTelephone: '联系方式',
    address: '联系地址',
    contactEmail: '联系邮箱',
    contactPerson: '负责人',
    contactPersonSig: '负责人签名',
    contactOther: '其他'
  },
  vgmInfo: {
    title: 'VGM 信息查询',
    blNo: '提单号',
    containerNo: '箱号',
    queryType: '查询类型',
    bookingNo: '订舱号',
    vvl: '船名航次',
    containerType: '箱型',
    vgmGrossWeight: 'VGM箱总重',
    vgmScale: 'VGM称重单位',
    vgmMethod: 'VGM称重方法',
    vgmDate: 'VGM称重时间',
    location: 'VGM称重地点',
    VVLNotNull: 'VVL不能为空！',
    weightNotNull: 'VGM箱总重不能为空！',
    methodNotNull: 'VGM称重方法不能为空！',
    scaleNotNull: 'VGM称重单位不能为空！',
    weightAbnormal: '箱总重不小于2000且不大于50000！',
    bkblNoNotNull: '订舱号，提单号必填一个！',
    emailMessage: '请输入正确的邮箱地址！',
    containerMessage: '箱号格式不正确！'
  },
  validate: {
    userNameNotNull: '请输入账号',
    userNameISNull: '账号不为空',
    userNameExist: '账号已存在',
    userNameIsWrong: '账号不少于5位且不大于25位',
    nameIsNull: '姓名不能为空',
    passwordNotNull: '请输入密码',
    passwordIsShort: '密码不能为空且不少于6位',
    passwordIsSimple: '必须包含大小写字母以及特殊字符',
    passwordNotTrue: '两次输入密码不一致',
    emailNotNull: '邮箱不能为空',
    authorizeCodeNotExist: '授权码不存在,请发送邮件至邮箱：cs-shipping@sitc.com 获取授权码',
    authorizeCodeNotNull: '授权码不为空,请发送邮件至邮箱：cs-shipping@sitc.com 获取授权码',
    emailNotTrue: '邮箱格式不正确！',
    code: '请输入验证码',
    pol: '起运港不能为空',
    pod: '目的港不能为空',
    vesselName: '船舶名称不能为空',
    blNo: ' 提单号不能为空! ',
    containerNo: ' 箱号不能为空! ',
    date: '起始日期不能为空',
    checkBlNo: '提单号/箱号有误！',
    inputNo: '输入不为空',
    refNo: '申请号不能为空',
    bkNo: '订舱号不能为空'
  }
};